import ApiService from '@/services/api.service';

const state = {
  isLoading: false,
  error: null,
  buyerTypes: {
    data: [],
    meta: {
      page: {},
    },
  },
};

const getters = {
  getLoading: (state) => {
    return state.isLoading;
  },
  getBuyerTypes: (state) => {
    return state.buyerTypes;
  },
  getError: (state) => {
    return state.error;
  },
};

const mutations = {
  setLoader: (state, status) => (state.isLoading = status),
  setBuyerTypes: (state, data) => (state.buyerTypes = data),
  setError: (state, data) => (state.error = data),
};

const actions = {
  async fetchBuyerTypes(
    { commit },
    { keyword, pageNumber, pageSize, search, ...others } = {}
  ) {
    commit('setLoader', true);
    const params = { ...others };
    let filter = [];
    let page = [];
    if (keyword && keyword !== '') filter['code'] = keyword;
    if (pageNumber && pageNumber !== '') page['number'] = pageNumber;
    if (pageSize) page['size'] = pageSize;
    if (search && search !== '') filter['search'] = search;
    Object.keys(page).map((item) => {
      const key = `page[${item}]`;
      Object.assign(params, { [key]: page[item] });
    });
    Object.keys(filter).map((item) => {
      const key = `filter[${item}]`;
      Object.assign(params, { [key]: filter[item] });
    });

    Object.assign(params, { sort: '-createdAt' });
    try {
      let response = await ApiService.get('/api/v1/buyer-types', {
        params,
      });
      commit('setBuyerTypes', response.data);
      commit('setError', null);
      commit('setLoader', false);
      return response;
    } catch (error) {
      commit('setBuyerTypes', {
        data: [],
        meta: {
          page: {},
        },
      });
      commit('setError', error);
    }
    commit('setLoader', false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
